export const FEATURE_FLAG_MERGE_PROFILES = 'merge-profiles'
